<div class="row filter-component-custom" *ngIf="shipmentFilter?.shipmentName">
    <div class="col-md-12">
        <div class="row ml-1 mr-1">
            <div class="filter-header-style" i18n="@@label_shipment_name">Shipment Name</div>
            <div class="filtered-item"><span class="filter-content-style">{{shipmentFilter?.shipmentName}}</span><button class="filter-close-button" (click)="clearSelectedFilter()"><i class="fa fa-close"></i></button></div>
        </div>
    </div>
</div>
 